import {
  LAZYLOAD_IMAGE_ATTRIBUTE,
  ORIGINAL_IMAGE_ATTRIBUTE,
  LAZYLOAD_CLASS_NAME
} from '../../classnames/lazyload';

export default class ImageHandler {
  handle = ({ smallImage, image }, node) => {
    const imageElements = node.getElementsByClassName('js-variant-image');

    [...imageElements].forEach((element) => {
      element.setAttribute(LAZYLOAD_IMAGE_ATTRIBUTE, smallImage);
      element.setAttribute(ORIGINAL_IMAGE_ATTRIBUTE, image);
      element.classList.add(LAZYLOAD_CLASS_NAME);
    });
  };
}
